module.exports = __webpack_public_path__ + "img/wxcode.8bba54f0.jpg";